module.exports = __webpack_public_path__ + "media/Bitfluent-Mobile-Video.986a2c5b.mp4";